export default "__VITE_ASSET__D$BdNHoQ__"